import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { Button } from "@wellcheck/components/ui/button";

import { DEFAULT_LOCALE, isSupportedLocale } from "@/i18n/config";

/**
 * NotFoundPage — 未定義ルートまたは loader エラー時に表示される最小画面。
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const current = isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;

  return (
    <main className="mx-auto max-w-3xl px-6 py-10">
      <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
        <h2 className="text-base font-semibold">{t("notFound.title")}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{t("notFound.description")}</p>
        <Button asChild variant="outline" className="mt-6">
          <Link to={`/${current}`}>{t("notFound.back")}</Link>
        </Button>
      </section>
    </main>
  );
}
